// src/utils/scheduleData.js
export const scheduleData = {
    en: {
        title: "Daily Schedule of Mahãvihãra",
        schedule: [
            { time: "4:15 AM", activity: "Wake up, Wash face" },
            { time: "4:30 AM", activity: "Morning Buddhist Chanting" },
            { time: "After Morning Chanting - 5:10 AM", activity: "Meditation" },
            { time: "5:10 AM - 5:30 AM", activity: "Monastery Cleaning" },
            { time: "Dawn", activity: "Morning Meal Offering" },
            { time: "After Morning Meal", activity: "Alms Round in Town/Village" },
            { time: "7:00 AM - 10:00 AM", activity: "Scripture Study/Recitation" },
            { time: "10:00 AM - 10:45 AM", activity: "Bathing Time" },
            { time: "10:45 AM", activity: "Main Meal of the Day" },
            { time: "After Meal - 12:00 PM", activity: "Scripture Recitation to Teachers" },
            { time: "12:00 PM - 1:00 PM", activity: "Rest Period" },
            { time: "1:00 PM - 5:30 PM", activity: "Scripture Study/Recitation" },
            { time: "5:30 PM - 6:00 PM", activity: "Group Scripture Recitation, Walking Meditation" },
            { time: "6:10 PM - 7:00 PM", activity: "10-minute Meditation followed by Evening Chanting" },
            { time: "After Evening Chanting - 7:30 PM", activity: "Dhamma Listening" },
            { time: "7:30 PM - 8:00 PM", activity: "Refreshments and Scripture Recitation to Teachers" },
            { time: "8:00 PM - 10:00 PM", activity: "Scripture Study/Recitation" },
            { time: "10:00 PM - 4:15 AM", activity: "Rest Period" }
        ],
        notes: [
            "During alms round and study times, those with teaching duties do not go for alms. Those without teaching duties or alms round must attend study sessions.",
            "Novice monks under 14 years of age may rest from 9:00 PM.",
            "Weekly examinations are held on Uposatha days, during which regular teaching activities are suspended.",
            "The above schedule is followed daily except on Uposatha days, maintaining both theoretical and practical aspects of Buddhist studies."
        ]
    },
    my: {
        title: "မဟာဝိဟာရ၏ တစ်နေ့တာ အချိန်ဇယား",
        schedule: [
            { time: "နံနက် ၄း၁၅ နာရီ", activity: "အိပ်ရာထ၊ မျက်နှာသစ်" },
            { time: "နံနက် ၄း၃၀ နာရီ", activity: "ဘုရားဝတ်တက်" },
            { time: "နံနက် ဝတ်တက်အပြီး မှ ၅း၁၀ နာရီ", activity: "တရားထိုင်" },
            { time: "နံနက် ၅း၁၀ နာရီ မှ ၅း၃၀ နာရီ", activity: "ကျောင်းတိုက်သန့်ရှင်းရေး" },
            { time: "အရုဏ်တက်ချိန်", activity: "အရုဏ်ဆွမ်းဘုဉ်းပေးရန်" },
            { time: "အရုဏ်ဆွမ်းဘုဉ်းပြီးချိန်", activity: "မြို့တွင်း/ရွာတွင်း ဆွမ်းခံထွက်ရန်" },
            { time: "နံနက် ၇:၀၀ နာရီ မှ ၁၀:၀၀ နာရီ ထိ", activity: "စာဝါ/စာအံကျောင်းတက်ရန်" },
            { time: "နံနက် ၁၀:၀၀ နာရီ မှ ၁၀:၄၅ နာရီ ထိ", activity: "ရေချိုးရန်" },
            { time: "နံနက် ၁၀:၄၅ နာရီ", activity: "နေ့ဆွမ်းဘုဉ်းပေးရန်" },
            { time: "နေ့ဆွမ်းဘုဉ်းပေးပြီးချိန်မှ မွန်းတည့် ၁၂:၀၀ နာရီ ထိ", activity: "အာမခံဆရာများထံ စာပြန်ကြရန်" },
            { time: "မွန်းတည့် ၁၂:၀၀ နာရီ မှ နေ့လယ် ၁:၀၀ နာရီ ထိ", activity: "အိပ်စက် အနားယူကြရန်" },
            { time: "နေ့လယ် ၁:၀၀ နာရီ မှ ညနေ ၅:၃၀ နာရီ ထိ", activity: "စာဝါ/စာအံကျောင်းတက်ရန်" },
            { time: "ညနေ ၅:၃၀ နာရီ မှ ည ၆:၀၀ နာရီ ထိ", activity: "အာမခံဆရာထံ စာပြန်၊ ဝိုင်းဖွဲ့လျက် စာဆို၊ လမ်းလျှောက်ကြရန်" },
            { time: "ည ၆:၁၀ နာရီ မှ ည ၇:၀၀ နာရီ ထိ", activity: "၁၀-မိနစ် တရားထိုင်ပြီး ဘုရားဝတ်တက်ရန်" },
            { time: "ည ဝတ်တက်အပြီး မှ ၇:၃၀ နာရီ ထိ", activity: "ဩဝါဒနာကြရန်" },
            { time: "ည ၇:၃၀ နာရီ မှ ည ၈:၀၀ နာရီ ထိ", activity: "ဖျော်ရည်ဘုဉ်း၊ အာမခံဆရာထံ စာပြန်ကြရန်" },
            { time: "ည ၈:၀၀ နာရီ မှ ည ၁၀:၀၀ နာရီ ထိ", activity: "စာဝါ/စာအံကျောင်းတက်ရန်" },
            { time: "ည ၁၀:၀၀ နာရီ မှ နံနက် ၄:၁၅ နာရီ ထိ", activity: "အိပ်စက်အနားယူကြရန်" }
        ],
        notes: [
            "ဆွမ်းခံချိန်နှင့် စာအံကျောင်းချိန်များတွင် စာဝါရှိသူများ ဆွမ်းခံမထွက်ရ၊ စာဝါလည်းမရှိ ဆွမ်းခံလည်း မလိုက်ရသူများ စာအံကျောင်းတက်ရသည်။",
            "ည ၉:၀၀ နာရီတွင် အသက် ၁၄-နှစ် မပြည့်သေးသော သာမဏေငယ်များ အိပ်စက်အနားယူနိုင်ပါသည်။",
            "တစ်ပတ်တွင် ဥပုသ်နေ့တစ်ရက်သာ အပတ်စဉ်စာမေးပွဲဖြေဆိုရသောကြောင့် စာသင်စာချ နားရ၏။",
            "အခြား ၆-ရက်တွင် အထက်ပါအချိန်ဇယားအတိုင်း နေ့စဉ် ပရိယတ် ပဋိပတ်ဖြင့် လည်ပတ် လျက်ရှိကြ၏။"
        ]
    }
};